import { Component, inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core'
import { DomSanitizer, SafeUrl } from '@angular/platform-browser'

import { DynamicDialogConfig } from 'primeng/dynamicdialog'

import { WorkflowsService } from '@app/generated/api/workflows/workflows.service'

@Component({
  templateUrl: 'workflow-visualisation.component.html',
})

export class WorkflowVisualisationComponent implements OnInit, OnDestroy {
  public readonly config = inject(DynamicDialogConfig)
  private readonly locale = inject(LOCALE_ID)
  private readonly workflowsService = inject(WorkflowsService)
  private readonly domSanitizer = inject(DomSanitizer)
  private objectUrl?: string

  detail: any = {}
  imageUrl?: SafeUrl
  workflowName?: string

  ngOnInit (): void {
    this.workflowName = this.config.data.workflowName

    if (this.workflowName) {
      this.workflowsService.retrieve(this.workflowName, { locale: this.locale }).subscribe((blob: Blob) => {
        this.objectUrl = URL.createObjectURL(blob)
        this.imageUrl = this.domSanitizer.bypassSecurityTrustUrl(this.objectUrl)
      })
    }
  }

  ngOnDestroy (): void {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
  }
}
